<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     增值-新建优惠券方案
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="ei-coupon-create">
    <div class="main-header">
      <div class="title">
        <f-back />
        <span>{{ $route.meta.title }}</span>
      </div>
      <div class="toolbox">&nbsp;</div>
    </div>
    <el-card shadow="never">
      <div class="front-line">券面设置</div>
      <el-form v-loading="postLoading" ref="couponForm" class="mt-lg" label-position="left" :model="coupon" :rules="couponRules" label-width="120px">
        <el-form-item label="券类型">
          <el-radio-group v-model="coupon.coupon_type">
            <el-radio :label="1">满减券</el-radio>
            <!-- <el-radio :label="2">折扣券</el-radio> -->
            <el-radio :label="3">新用户券</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="优惠方式" required>
          <div v-if="coupon.coupon_type == 1" class="flex align-items-center">
            <span class="mr-md">满</span>
            <el-form-item prop="least_cost">
              <el-input v-model="coupon.least_cost" placeholder="填写金额" style="width: 160px;" @input="limitInput($event, 1)">
                <template slot="prepend">￥</template>
              </el-input>
            </el-form-item>
            <span class="ml-md mr-md">减</span>
            <el-form-item prop="discount_fee">
              <el-input v-model="coupon.discount_fee" placeholder="填写金额" style="width: 160px;" @input="limitInput($event, 2)">
                <template slot="prepend">￥</template>
              </el-input>
            </el-form-item>
          </div>
          <el-form-item v-else-if="coupon.coupon_type == 2" prop="discount_rate">
            <el-input v-model="coupon.discount_rate" placeholder="输入折扣" style="width: 160px;" @input="limitInputRate($event)">
              <template slot="append">折</template>
            </el-input>
          </el-form-item>
          <div v-else-if="coupon.coupon_type == 3" class="flex align-items-center">
            <span class="mr-md">满</span>
            <el-form-item prop="least_cost">
              <el-input v-model="coupon.least_cost" placeholder="填写金额" style="width: 160px;" @input="limitInput($event, 1)">
                <template slot="prepend">￥</template>
              </el-input>
            </el-form-item>
            <span class="ml-md mr-md">减</span>
            <el-form-item prop="discount_fee">
              <el-input v-model="coupon.discount_fee" placeholder="填写金额" style="width: 160px;" @input="limitInput($event, 2)">
                <template slot="prepend">￥</template>
              </el-input>
            </el-form-item>
          </div>
        </el-form-item>
        <el-form-item label="券有效期" prop="valid_days">
          <div class="flex align-items-center">
            <span class="mr-sm">领取后</span>
            <el-input v-model="coupon.valid_days" placeholder="填写天数" style="width: 160px;" @input="(v) => (coupon.valid_days = v.replace(/[^\d]/g, ''))">
              <template slot="append">天</template>
            </el-input>
            <span class="ml-sm">内有效</span>
          </div>
        </el-form-item>
        <el-form-item label="启用领券">
          <el-switch v-model="coupon.receive_enable" :active-value="2" :inactive-value="1" />
        </el-form-item>
        <el-form-item label="说明：">
          <div class="text-muted">1、本券仅限于远程监控服务续费使用；</div>
          <div v-if="coupon.coupon_type == 3" class="text-muted">2、本券支持新用户领取1次，过期作废；</div>
          <div v-else class="text-muted">2、本券支持用户多次领取，每使用1张后再领取；</div>
          <div class="text-muted">3、本券一次使用1张，不限设备数量；</div>
          <div class="text-muted">4、本券可与促销活动叠加使用。</div>
        </el-form-item>
      </el-form>
      
      
    </el-card>

    <div class="mt-md flex align-items-center">
      <el-button @click="$router.go(-1)">取 消</el-button>
      <el-button type="primary" :loading="postLoading" @click="submit">创 建</el-button>
    </div>
  </div>
</template>

<script>
import { couponCreateApi } from "@/api/ei/eiCouponApi"

export default {
  name: "EiCouponCreate",

  components: {
  },

  data() {
    let limitNumber = (rule, value, callback) => {
      const field = rule.field
      if (field == 'valid_days'){
        if (value < 1 || value > 180) {
          callback(new Error("券有效期不能超过180天，请输入正确的天数"));
          return;
        } else {
          callback();
        }
      }
        
      if (this.coupon.coupon_type == 1 || this.coupon.coupon_type == 3) {
        if (field == 'least_cost' && !value) {
          callback(new Error("请输入满减条件金额"));
          return;
        } 
        if (field == 'least_cost' && value <= Number(this.coupon.discount_fee)) {
          callback(new Error("满减条件金额不能小于满减折扣金额"));
          return;
        }
        if (field == 'discount_fee' && !value) {
          callback(new Error("请输入满减折扣金额"));
          return;
        }
        if (field == 'discount_fee' && value >= Number(this.coupon.least_cost)) {
          callback(new Error("满减折扣金额不能大于满减条件金额"));
          return;
        }
        callback();
      }
      if (this.coupon.coupon_type == 2 && field == 'discount_rate') {
        if (!value) {
          callback(new Error("请输入折扣"));
          return;
        }
        if (value > 9.9 || value < 1) {
          callback(new Error("请输入正确的折扣，折扣范围：1~9.9"));
          return;
        }
        callback();
      }
    }
    return {
      postLoading: false,
      coupon: {
        coupon_type: 1,
        least_cost: null,
        discount_fee: null,
        discount_rate: null,
        valid_days: null,
        receive_enable: 2
      },

      couponRules: {
        least_cost: [
          { validator: limitNumber, trigger: "blur" },
        ],
        discount_fee: [
          { validator: limitNumber, trigger: "blur" },
        ],
        discount_rate: [
          { validator: limitNumber, trigger: "blur" },
        ],
        valid_days: [
          { required: true, message: "请填写天数", trigger: "blur" },
          { validator: limitNumber, trigger: "blur" },
        ],
      }
    }
  },

  computed: {
  },

  created() {
  },

  methods: {
    limitInput(value, type) {
      const val = ('' + value)
      .replace(/[^\d^\.]+/g, '') // 第二步：把不是数字，不是小数点的过滤掉
      .replace(/^0+(\d)/, '$1') // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
      .replace(/^\./, '0.') // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
      .match(/^\d*(\.?\d{0,2})/g)[0] || ''
      if (type == 1) this.coupon.least_cost = val
      if (type == 2) this.coupon.discount_fee = val
    },

    limitInputRate(value) {
      const val = ('' + value)
      .replace(/[^\d^\.]+/g, '') // 第二步：把不是数字，不是小数点的过滤掉
      .replace(/^0+(\d)/, '$1') // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
      .replace(/^\./, '0.') // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
      .match(/^\d*(\.?\d{0,1})/g)[0] || ''
      this.coupon.discount_rate = val
    },
    
    submit() {
      this.$refs["couponForm"].validate((valid) => {
        if (valid) {
          const name = this.coupon.coupon_type == 1 || this.coupon.coupon_type == 3 ? '满' + this.coupon.least_cost + '减' + this.coupon.discount_fee + '元' : this.coupon.discount_rate + '折'
          this.$confirm(`即将创建 <span class="text-primary">${name}</span> 的优惠券方案，是否继续？`, '提示', {
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then(() => {
            this.loading = true
            const temp = {
              coupon_type: this.coupon.coupon_type,
              valid_days: Number(this.coupon.valid_days),
              receive_enable: this.coupon.receive_enable
            }
            if (temp.coupon_type == 1 || temp.coupon_type == 3) {
              temp.least_cost = Number(this.coupon.least_cost)
              temp.discount_fee = Number(this.coupon.discount_fee)
            }
            if (temp.coupon_type == 2) {
              temp.discount_rate = Number(this.coupon.discount_rate)
            }
            couponCreateApi(temp).then(res => {
              this.loading = false
              if (!res.errno) {
                this.$router.push('/ei/coupon')
                this.$message.success(name + '优惠券方案创建成功！')
              } else {
                this.$message.error(res.message)
              }
            })
          }).catch(() => {
          })
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.ei-coupon-create {
}
</style>